'use strict';

var App = require('app');
var BaseDeviceController = require('components/devices/controllers/base_device_controller');
var ConnectionInfoDialogView = require('components/devices/views/gateway/connection_info_dialog_view');

var GatewayController = BaseDeviceController.extend({
    deviceReplacement: function (options) {
        var replacementResult = App.request('device:replacement', options.replaced_id, options.new_id, options.mode);

        $.when(replacementResult).done(function (result) {
            if (result === undefined) {
                options.error_cb();
            } else {
                options.success_cb(result);
            }
        });
    },

    writeFirmwareConfig: function (options) {
        var cfgUpdateReq = App.request('gateway:firmwareconfig:write', options.device, options.config);
        $.when(cfgUpdateReq).done(function (result) {
            if (result === undefined) {
                options.error_cb();
            } else {
                options.success_cb(result);
            }
        });
    },

    showConnectionInfoDialog: function (req) {
        var view = new ConnectionInfoDialogView({ infoReq: req });
        App.showModal(view);
    },
});

module.exports = GatewayController;
